/*
    All the products belonging to the subcategories listed in the following array
    will display a control in the product page with which the user could select the maturity before adding it to the cart
*/
export default ['0202', '0201']
